import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

import UserValidationProvider from "../users/components/user-validation-provider";

const BankAccountList = lazy(() => import("./list"));
const BankAccountForm = lazy(() => import("./form"));

export const bankAccountRoutes: RouteObject[] = [
  {
    path: "accounts/list",
    element: (
      <Suspense fallback={null}>
        <UserValidationProvider>
          <BankAccountList />
        </UserValidationProvider>
      </Suspense>
    ),
  },
  {
    path: "accounts/new",
    element: (
      <Suspense fallback={null}>
        <BankAccountForm />
      </Suspense>
    ),
  },
];
